function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { palette } from '@cbhq/cds-web/tokens';
import '../Div/index.js';
import { Text } from '../Text.js';
import { jsx } from 'react/jsx-runtime';
import { Div } from '../Div/Div.js';
function Tabs({
  pillTabs = [],
  onTabChange,
  color = 'foreground'
}) {
  const _useState = useState(pillTabs[0]),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  useEffect(() => onTabChange && onTabChange(activeTab.id), [onTabChange, activeTab.id]);
  const onClick = tab => {
    if (tab) setActiveTab(tab);
  };
  return /*#__PURE__*/jsx(Div, {
    gap: 4,
    overflowX: {
      sm: 'auto',
      md: 'hidden'
    },
    children: pillTabs.map(tab => {
      const isActive = activeTab.id === tab.id;
      return (/*#__PURE__*/
        // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
        jsx(Div, {
          onClick: () => onClick(tab),
          children: /*#__PURE__*/jsx(Text, {
            as: "p",
            variant: "headline",
            spacingVertical: 2,
            spacingHorizontal: 0,
            color: isActive ? 'primary' : color,
            css: {
              cursor: 'pointer',
              borderBottom: isActive ? `2px solid ${palette.primary}` : 'none'
            },
            children: tab.label || tab.id
          })
        }, tab.id)
      );
    })
  });
}
export { Tabs };
//# sourceMappingURL=Tabs.js.map
